import { Box } from "@mui/material";
import { createColumnHelper } from "@tanstack/react-table";
import { getCurrency, getNumberFormat } from "../../utils/helper";

const columnHelper = createColumnHelper();

const formatQty = (value) => {
  if (value === null || value === undefined || value === "") return "\u2014";
  return getNumberFormat(value);
};

const formatCell = (value) =>
  value === null || value === undefined || value === "" ? "\u2014" : value;

export const inRepairRoDetailPnColumnData = [
  columnHelper.accessor("PN", {
    id: "PN",
    header: "Part Number",
    isVisible: true,
    cell: ({ row }) => formatCell(row.original.PN),
  }),
  columnHelper.accessor("ro_item_number", {
    id: "ro_item_number",
    header: "Item NO",
    isVisible: true,
    cell: ({ row }) => formatCell(row.original.ro_item_number),
  }),
  columnHelper.accessor("ro_status", {
    id: "ro_status",
    header: "RO Status",
    isVisible: true,
    cell: ({ row }) => formatCell(row.original.ro_status),
  }),
  columnHelper.accessor("qty_repaired", {
    id: "qty_repaired",
    header: "QTY Repaired",
    isVisible: true,
    cell: ({ row }) => formatQty(row.original.qty_repaired),
  }),
  columnHelper.accessor("qty_reserved", {
    id: "qty_reserved",
    header: "QTY Reserved",
    isVisible: true,
    cell: ({ row }) => formatQty(row.original.qty_reserved),
  }),
  columnHelper.accessor("qty_scrapped", {
    id: "qty_scrapped",
    header: "QTY Scrapped",
    isVisible: true,
    cell: ({ row }) => formatQty(row.original.qty_scrapped),
  }),
  columnHelper.accessor("qty_sent", {
    id: "qty_sent",
    header: "QTY Sent",
    isVisible: true,
    cell: ({ row }) => formatQty(row.original.qty_sent),
  }),
  columnHelper.accessor("misc_cost", {
    id: "misc_cost",
    header: "MISC Cost",
    isVisible: true,
    cell: ({ row }) => {
      const value = row.original.misc_cost;
      if (value === null || value === undefined || value === "") return "\u2014";
      return getCurrency(value) || "\u2014";
    },
  }),
];
